import React from 'react';
import {
  PageAlertsBlock,
  PageCustomBlock,
  PageMapBlock,
  type PageCabinetBlock,
  type PageEventsBlock,
  type PageNewsletterBlock,
  type PageProceduresBlock,
  type PageQuickAccessBar,
  type PageRegulationsBlock,
  type PageSliderBlock,
  type PageSocialNetworksBlock,
  type PageTaxesBlock,
} from '@common/Providers/GraphqlProvider/generated';

import { TypeNamePageBlocks } from '@/utils/constants';
import { PageBlockUnion } from '@/components/common/Providers/GraphqlProvider/generated';
import AlertBlock from '@/components/blocks/PageAlertsBlock/public/AlertBlock';
import Cabinet from '@/components/blocks/PageCabinetBlock/public/Cabinet';
import CustomBlock from '@/components/blocks/PageCustomBlock/public';
import Events from '@/components/blocks/PageEventsBlock/public';
import MapBlockPresentation from '@/components/blocks/PageMapBlock/public';
import News from '@/components/blocks/PageNewsletterBlock/public';
import Procedures from '@/components/blocks/PageProceduresBlock/public';
import QuickAccessBar from '@/components/blocks/PageQuickAccessBar/public';
import LastUpdate from '@/components/blocks/PageRegulationsBlock/public';
import Banner from '@/components/blocks/PageSliderBlock/public';
import { PressRoomSocialNetworksWithoutContext } from '@/components/blocks/PageSnsBlock/public/News';
import FollowUs from '@/components/blocks/PageSocialNetworksBlock/public';
import Taxes from '@/components/blocks/PageTaxesBlock/public';

type Props = {
  block: PageBlockUnion;
};

export default function PublicBlockRegistry({ block }: Props) {
  switch (block.__typename) {
    case TypeNamePageBlocks.PageSliderBlock:
      return <Banner currentSliderBlock={block as PageSliderBlock} />;

    case TypeNamePageBlocks.PageCabinetBlock:
      return <Cabinet currentCabinetBlock={block as PageCabinetBlock} />;

    case TypeNamePageBlocks.PageTaxesBlock:
      return <Taxes currentPageTaxesBlock={block as PageTaxesBlock} />;

    case TypeNamePageBlocks.PageNewsletterBlock:
      return <News currentPageNewsletterBlock={block as PageNewsletterBlock} />;

    case TypeNamePageBlocks.PageProceduresBlock:
      return <Procedures currentPageProceduresBlock={block as PageProceduresBlock} />;

    case TypeNamePageBlocks.PageRegulationsBlock:
      return <LastUpdate currentPageRegulationsBlock={block as PageRegulationsBlock} />;

    case TypeNamePageBlocks.PageEventsBlock:
      return <Events currentPageEventsBlock={block as PageEventsBlock} />;

    case TypeNamePageBlocks.PageSocialNetworksBlock:
      return <FollowUs currentPageSocialNetworks={block as PageSocialNetworksBlock} />;

    case TypeNamePageBlocks.PageQuickAccessBar:
      return <QuickAccessBar currentPageQuickAccessBar={block as PageQuickAccessBar} />;

    case TypeNamePageBlocks.PageCustomBlock:
      return <CustomBlock currentPageCustomBlock={block as PageCustomBlock} />;

    case TypeNamePageBlocks.PageSnsBlock:
      return (
        <div className="container mx-auto max-w-screen-xl p-5">
          <PressRoomSocialNetworksWithoutContext showSnsBlock={true} snsBlock={block as any} />
        </div>
      );

    case TypeNamePageBlocks.PageAlertsBlock:
      const alertBlock = block as PageAlertsBlock;
      const { title, ...rest } = alertBlock;
      return <AlertBlock block={{ ...rest, title } as PageAlertsBlock} />;

    case TypeNamePageBlocks.PageMapBlock:
      return (
        <div className="container mx-auto max-w-screen-xl p-5">
          <MapBlockPresentation currentPageMapBlock={block as PageMapBlock} />
        </div>
      );
    default:
      return null;
  }
}
